import { FormControl, InputLabel, Modal, Snackbar, Alert, Box, CircularProgress, createTheme, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorHandling } from "../../components/Errors/Errors";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista";
import servSolicitacaoVistoria from "../../services/login/servSolicitacaoVistoria";
import { logout } from "../../state/slices/userSlice";
import { columnsSolicitacaoVistoria } from "./Lista";
import Popup from "../../components/Popup";
import { style as modalStyle } from "../../components/Loading/Loading";
import styles from "./SolicitacaoVistoria.module.css";
import Cadastro from "./Cadastro";
import Analise from "./Analise";
import ResultadoAnalise from "./ResultadoAnalise";
import ResultadoAgendamento from "./ResultadoAgendamento";
import { newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import { setCurrentSolicitacaoVistoria } from "../../state/slices/analisesSlice";
import { parse } from "date-fns";
import servAnalises from "../../services/login/servAnalises";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { OpcoesSituacaoSolicVistoria } from "../../components/Combobox/SituacaoSolicVistoria";
import Select from 'react-select';
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";
import { OpcoesPeriodoDatas } from "../../components/Combobox/PeriodoDatas";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import servFileIni from "../../services/login/servFileIni";
import ArquivarSolicVistoria from "./ArquivarSolicVistoria";
import ArquivamentoSolicVistoria from "./ArquivamentoSolicVistoria";
import servSolicitacaoAcesso from "../../services/login/servSolicitacaoAcesso";

const SolicitacaoVistoria = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user);

    const [filtro, setFiltro] = useState("");
    const [filtroCodigoSolicitacaoAcesso, setFiltroCodigoSolicitacaoAcesso] = useState("");
    const [situacaoSolicVistoria, setSituacaoSolicVistoria] = useState([]);
    const [solicitacoes, setSolicitacoes] = useState([]);

    const [tipoPeriodo, setTipoPeriodo] = useState({ value: 8, label: 'Este mês' });
    const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
    const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
    const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());

    const [openCadastro, setOpenCadastro] = useState(false);
    const [ehNovoCadastro, setEhNovoCadastro] = useState(false);
    const [openAnalise, setOpenAnalise] = useState(false);

    const [openVisualizarAnalise, setOpenVisualizarAnalise] = useState(false);
    const [podeVisualizarAnalise, setPodeVisualizarAnalise] = useState(false);
    const [openVisualizarAgendamento, setOpenVisualizarAgendamento] = useState(false);
    const [podeVisualizarAgendamento, setPodeVisualizarAgendamento] = useState(false);
    const [podeSolicitarArquivamento, setPodeSolicitarArquivamento] = useState(false);
    const [openVisualizarArquivamento, setOpenVisualizarArquivamento] = useState(false);
    const [podeVisualizarArquivamento, setPodeVisualizarArquivamento] = useState(false);
    const [openArquivamento, setOpenArquivamento] = useState(false);
    const [solicitacaoAcesso, setSolicitacaoAcesso] = useState(null);

    const [recordForEdit, setRecordForEdit] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);

    const [analise, setAnalise] = useState(null);

    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color: "#d2d4d2"
                    }
                }
            }
        }
    });

    useEffect(() => {
        const recuperarDados = async (filtroDatas) => {
            try {
                setIsLoading(true);

                let dados;

                if(!filtroDatas) {
                    dados = await servSolicitacaoVistoria.ListarCFiltros(user.codigoUsuario, "");
                } else {
                    let arraySituacoes = [];
                    
                    arraySituacoes = situacaoSolicVistoria.map((item) => item.value);

                    dados = await servSolicitacaoVistoria.listarCfeSituacaoOuDatas(user.codigoUsuario, 
                                                                                filtro, 
                                                                                filtroCodigoSolicitacaoAcesso,
                                                                                arraySituacoes, 
                                                                                tipoDataFiltro,
                                                                                filtroDatas.dataInicial, 
                                                                                filtroDatas.dataFinal);
                }

                let content = dados?.Content;

                if (dados?.Content.length === 0) {
                    return setIsLoading(false);
                }

                content && content.map((solicitacao) => {
                    return solicitacao.id = solicitacao.Id
                });

                setSolicitacoes(content);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                )
            }
        }

        const recuperarUltimoTipoPeriodoDefinido = async () => {
            try {
                setIsLoading(true);

                let dto = {
                    CodigoUsuario: user.codigoUsuario.toString(),
                    CodigoSecao: "TIPO_PERIODO_P3",
                    Chave: "IDTIPOPERIODOSOLICVISTORIA",
                    Conteudo: ""
                };

                let response = await servFileIni.Recuperar(dto);
                let novasDatas;

                if(response.Content.trim() !== "") {
                    let conteudo = Number(response.Content);
                    let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;
                    
                    await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
                    novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
                } else {
                    await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
                    novasDatas = retornaDatasCfeTipoPeriodo(8); // 8 - Este mês
                }

                if (solicitacoes.length === 0) {
                    recuperarDados(novasDatas);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status, 
                    err?.Message, 
                    setOpenError, 
                    setErrorMessage, 
                    dispatch, 
                    logout, 
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        recuperarUltimoTipoPeriodoDefinido();
    }, []);

    useEffect(() => {
        if (recordForEdit === null) {
            setPodeVisualizarAnalise(false);
            setPodeVisualizarAgendamento(false);
            setPodeSolicitarArquivamento(false);
            setPodeVisualizarArquivamento(false);
            return;
        }

        let situacao = recordForEdit?.Situacao || (recordForEdit?.row?.Situacao ?? 0); 

        const situacoesNaoAnalisadas = [0];
        const situacoesAprovadas = [3, 4, 5];
        const situacaoArquivada = [6];
        const situacaoAprovadaEArquivada = [5, 6];

        situacoesNaoAnalisadas.includes(situacao) ? setPodeVisualizarAnalise(false) : setPodeVisualizarAnalise(true);
        situacoesAprovadas.includes(situacao) ? setPodeVisualizarAgendamento(true) : setPodeVisualizarAgendamento(false);
        situacaoArquivada.includes(situacao) ? setPodeSolicitarArquivamento(true) : setPodeSolicitarArquivamento(false);
        situacaoAprovadaEArquivada.includes(situacao) ? setPodeSolicitarArquivamento(false) : setPodeSolicitarArquivamento(true);
        situacaoArquivada.includes(situacao) ? setPodeVisualizarArquivamento(true) : setPodeVisualizarArquivamento(false);
    }, [recordForEdit]);

    const onClickPesquisar = async () => {
        try {
            setIsLoading(true);
            let dados;

            if(situacaoSolicVistoria.length === 0 &&
              (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") && 
              (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
                dados = await servSolicitacaoVistoria.ListarCFiltros(user.codigoUsuario, filtro);
            } else {
                let arraySituacoes = [];
                
                arraySituacoes = situacaoSolicVistoria.map((item) => item.value);

                dados = await servSolicitacaoVistoria.listarCfeSituacaoOuDatas(user.codigoUsuario, 
                                                                              filtro, 
                                                                              filtroCodigoSolicitacaoAcesso,
                                                                              arraySituacoes, 
                                                                              tipoDataFiltro,
                                                                              dataInicialFiltro, 
                                                                              dataFinalFiltro);
            }

            let content = dados?.Content;

            content && content.map((solicitacao) => {
                return solicitacao.id = solicitacao.Id            
            });

            setIsLoading(false);

            setSolicitacoes(content);

            if (content.length === 0) {
                setErrorMessage("Não foram encontrados registros para sua pesquisa");
                setOpenError(true);
            }
        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.response?.status, 
                err?.Message, 
                setOpenError, 
                setErrorMessage, 
                dispatch, 
                logout, 
                navigate,
                err?.response?.data?.Message);
        }
    }

    const adicionarNovaSolicitacao = () => {
        // setRecordForEdit(null);
        setEhNovoCadastro(true);
        setOpenCadastro(true);
    }

    const abrirSolicitacaoExistente = () => {
        setEhNovoCadastro(false);
        setOpenCadastro(true);
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const solicitarAnalise = () => {
        if (recordForEdit === null) { 
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacoesHomologaveis = [0, 2];

        if (situacoesHomologaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            return setOpenAnalise(true);
        }

        setErrorMessage("Só é possível solicitar análise de consultas com situação em digitação ou revisão");
        return setOpenError(true);
    }

    const visualizarAnalise = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        try {
            setIsLoading(true);
            
            let dados = await servAnalises.RecuperarUltimaAnaliseVistoria(recordForEdit?.row?.Id || recordForEdit?.Id);
            
            setIsLoading(false);

            formatarData(dados);
            setAnalise(dados.Content[0]);
            
            setOpenVisualizarAnalise(true)
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err.Message);
            setOpenError(true);
        }
    }

    const formatarData = (dados) => {
        let dataAnaliseF = dados.Content[0].DataAnalise;
        let dataApresentacaoF = dados.Content[0].DataApresentacao;

        dataAnaliseF = parse(dataAnaliseF, 'dd/MM/yyyy HH:mm:ss', new Date());
        dataApresentacaoF = parse(dataApresentacaoF, 'dd/MM/yyyy HH:mm:ss', new Date());

        dados.Content.DataAnalise = dataAnaliseF;
        dados.Content.DataApresentacao = dataApresentacaoF;
    }

    const visualizarAnalisesAnteriores = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacaoSemAnalise = 0;

        if (recordForEdit?.row?.Situacao === situacaoSemAnalise
            || recordForEdit?.Situacao === situacaoSemAnalise) {
            setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
            return setOpenError(true);
        }

        const listaSolicitacaoCon = {
            Nome: "Análises da solicitação de vistoria",
            Aba: 6
        }

        let id = recordForEdit?.row?.Id || recordForEdit?.Id;

        dispatch(newTab(listaSolicitacaoCon));
        dispatch(setTabFromNewIndex(listaSolicitacaoCon.Aba));
        dispatch(setCurrentSolicitacaoVistoria(id));
    }

    const visualizarAgendamento = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        let dados = await servSolicitacaoVistoria.RecuperarAgendamento(recordForEdit?.Id || recordForEdit?.row?.Id);

        if(dados.Content.Id === 0) {
            setIsLoading(false);
            setErrorMessage("A solicitação de vistoria selecionada não possui agendamento vinculado.");
            setOpenError(true);
            return;
        }

        return setOpenVisualizarAgendamento(true);
    }

    const handleTipoDataFiltro = (event) => {
        event.preventDefault();

        setTipoDataFiltro(event.target.value)
    }

    const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
        try {
            setTipoPeriodo(tipoPeriodo);

            let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
            setDataInicialFiltro(datasCalculadas.dataInicial);
            setDataFinalFiltro(datasCalculadas.dataFinal);

            let dto = {
                Chave: "IDTIPOPERIODOSOLICVISTORIA",
                Conteudo: tipoPeriodo.value.toString(),
                CodigoSecao: "TIPO_PERIODO_P3",
                CodigoUsuario: user.codigoUsuario.toString()
            };

            await servFileIni.Inserir(dto);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
            setOpenError(true);
            return;
        }
    }

    const solicitarArquivamento = async () => {
        if(recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        const situacoesAquivaveis = [0, 1, 2, 3, 4];

        let data = await servSolicitacaoAcesso.RecuperarSolicitacao(recordForEdit?.CodigoSolicitacaoAcesso || recordForEdit?.row?.CodigoSolicitacaoAcesso);

        setSolicitacaoAcesso(data);

        if (situacoesAquivaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesAquivaveis.includes(recordForEdit?.Situacao)) {
            return setOpenArquivamento(true);
        }

        setErrorMessage("Não é possível arquivar solicitações já aprovadas ou arquivadas.");
        return setOpenError(true);
    }

    const visualizarArquivamento = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        return setOpenVisualizarArquivamento(true);
    }

    return (
        <div className={styles.solicitacaoContainer}>
            <div className={styles.solicitacaoFiltros}>
                <FormControl>
                    <InputLabel shrink htmlFor="pesquisa-obs" style={{ color: "#B8B8B8", marginLeft: "10px" }} >Pesquisa geral<FontAwesomeIcon title="Este campo pesquisa por: código da solicitação de vistoria, código do orçamento de conexão, protocolo ou UC." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-obs" sx={{ width: "500px", margin: '0px 18px' }} /> 
                </FormControl>
            </div>
            <div className={styles.solicitacaoFiltros} style={{ marginTop: "20px"}}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Orç. de conexão</InputLabel>
                    <WhiteInput value={filtroCodigoSolicitacaoAcesso} onChange={(e) => setFiltroCodigoSolicitacaoAcesso(e.target.value)} placeholder="Orç. de conexão" id="pesquisa-codigo-solicitacao-acesso" sx={{ width: "200px", margin: '0px 18px' }} />
                </FormControl>
                <FormControl variant="outlined" sx={{ width: "450px", marginRight: "20px" }}>
                    <InputLabel htmlFor="pesquisa-obs-situacao" shrink style={{ color: "#B8B8B8" }}>
                        Situação
                    </InputLabel>
                    <Select     
                        isMulti={true}
                        value={situacaoSolicVistoria}
                        onChange={value => setSituacaoSolicVistoria(value)}
                        options={OpcoesSituacaoSolicVistoria}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
            </div>
            <div className={styles.solicitacaoFiltros}>
                <FormControl variant="outlined">
                    <InputLabel htmlFor="data-solicvistoria" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
                        <select className={styles.tipoDataFiltroConsulta} name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
                            <optgroup>
                                <option value="data-cadastro" selected>Data cadastro</option>
                                <option value="data-envio-homolog">Data envio homolog.</option>
                            </optgroup>
                        </select>
                    </InputLabel>
                    <div className={styles.solicitacaoVistoriaDatas}>
                        <Select
                            value={tipoPeriodo}
                            onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
                            options={OpcoesPeriodoDatas}
                            styles={SearchFieldStylesFiltro}
                            placeholder="Período"
                        />
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicialFiltro}
                                    onChange={(e) => setDataInicialFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                        <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataFinalFiltro}
                                    onChange={(e) => setDataFinalFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </div>
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginTop: "16.5px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>

            <div className={styles.solicitacaoBotoes}>
                <BlueHoverButton variant="contained" onClick={adicionarNovaSolicitacao}>Nova solicitação</BlueHoverButton>
                <BlueHoverButton variant="contained" onClick={solicitarAnalise}>Enviar para análise</BlueHoverButton>
                { podeVisualizarAnalise && (
                    <BlueHoverButton variant="contained" onClick={visualizarAnalise}>Resultado análise</BlueHoverButton>
                )}
                { podeVisualizarAnalise && (
                    <BlueHoverButton variant="contained" onClick={visualizarAnalisesAnteriores}>Resultados anteriores</BlueHoverButton>
                )}
                { podeVisualizarAgendamento && (
                    <BlueHoverButton variant="contained" onClick={visualizarAgendamento}>Visualizar acompanhamento</BlueHoverButton>
                )}
                { podeSolicitarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={solicitarArquivamento}>Arquivar</BlueHoverButton>
                )}
                { podeVisualizarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={visualizarArquivamento}>Arquivamento</BlueHoverButton>
                )}
            </div>
            <div className={styles.solicitacaoLista}>
                <Lista
                    columns={columnsSolicitacaoVistoria}
                    rows={solicitacoes}
                    onDblClick={abrirSolicitacaoExistente}
                    setSelectedData={setRecordForEdit}
                    hideFooter={false}
                    autoHeight={false}
                />
            </div>
            <Popup 
                title="Solicitação de vistoria" 
                openPopup={openCadastro} 
                setOpenPopup={setOpenCadastro}
                novoCadastro={ehNovoCadastro}
                setNovoCadastro={setEhNovoCadastro}
            >
                <Cadastro 
                    pesquisar={onClickPesquisar}
                    recordForEdit={recordForEdit}
                    setOpen={setOpenCadastro}
                    novoCadastro={ehNovoCadastro}
                    setEhNovoCadastro={setEhNovoCadastro}
                />
            </Popup>

            <Popup title="Enviar para análise" openPopup={openAnalise} setOpenPopup={setOpenAnalise} minHeight="100px" >
                <Analise 
                    pesquisar={onClickPesquisar}
                    record={recordForEdit}
                    setOpen={setOpenAnalise}
                />
            </Popup>

            <Popup title="Acompanhamento" openPopup={openVisualizarAgendamento} setOpenPopup={setOpenVisualizarAgendamento} minHeight="100px">
                <ResultadoAgendamento
                    setOpen={setOpenVisualizarAgendamento}
                    record={recordForEdit}
                />
            </Popup>

            <Popup title="Análise da solic. de vistoria" openPopup={openVisualizarAnalise} setOpenPopup={setOpenVisualizarAnalise} minHeight="100px">
                <ResultadoAnalise 
                    setOpen={setOpenVisualizarAnalise}
                    record={analise}
                />
            </Popup>

            <Popup title="Arquivar solicitação de vistoria" openPopup={openArquivamento} setOpenPopup={setOpenArquivamento} minHeight="100px">
                <ArquivarSolicVistoria 
                    setOpenPopup={setOpenArquivamento}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                    solicitacaoAcesso={solicitacaoAcesso}
                />
            </Popup>

            <Popup title="Arquivamento" openPopup={openVisualizarArquivamento} setOpenPopup={setOpenVisualizarArquivamento} minHeight="100px">
                <ArquivamentoSolicVistoria
                    setOpenPopup={setOpenVisualizarArquivamento}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>
            
            <Modal open={isLoading} >
                <Box style={modalStyle} >
                    <CircularProgress color="inherit" />
                </Box>    
            </Modal>
            <Snackbar open={openError} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={6000} onClose={handleCloseError}>
                <Alert onClose={handleCloseError} severity="error" sx={{ width: "100%" }}>
                    { errorMessage }
                </Alert>
            </Snackbar>
        </div>
    )
};


export { SolicitacaoVistoria }